import React, {useState,useMemo} from 'react';
import { Redirect } from "react-router-dom";
import { useMediaQuery } from '@mui/material';
import useStyles from './Styles';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';
import Grid from '@mui/material/Grid';
import Paper from '@mui/material/Paper';
//import Container from '@mui/material/Container';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableRow from '@mui/material/TableRow';
import TableHead from '@mui/material/TableHead';
import IconButton from '@mui/material/IconButton';
import CircularProgress from '@mui/material/CircularProgress';
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import DeleteForeverIcon from '@mui/icons-material/DeleteForever';
import AddIcon from '@mui/icons-material/Add';
import FestivalIcon from '@mui/icons-material/Festival';
import {Inc,Owner,KbinSearchCondition,Kbin,Item} from './Inc';
import {Tools} from './Tools';
import Ajax from './Ajax';
import Loading from './Loading';
import KbinListSearch from './KbinListSearch';
import KbinItems from './KbinItems';
import Title from './Title';
import Yesno from './Yesno';
import Toast from './Toast';
import MultiLines from './MultiLines';
import AppBank from './AppBank';
import {Theme} from './Theme';

interface KbinListProps {
	owner:Owner,
	bank:AppBank,
}
let page:number = 1;

const KbinList = (pr:KbinListProps)=> {
    Ajax.setEditorId( pr.owner.owner_id );
    const classes = useStyles();
    const [states,setStates] = useState({
        kbins:[] as Kbin[],
        isLoading:true,
		isItems:false,
		currentIndex:-1,
		editIndex:-1,
		action: '',
		items:[] as Item[],
		selectedItems:[] as Item[],
        pager:null,
        cond:Inc.defaultKbinSearchCondition(),
    });
	const isCompact = useMediaQuery(Theme.breakpoints.down('sm'));

    const search = (cond:KbinSearchCondition,first?:boolean)=>{
        //console.log("search",cond);
        setStates({...states,"isLoading":true});
        window.scrollTo(0,0);
        if( first ){
            page = 1;
        }
        Ajax.search("kbin/list",cond,page,(res:any)=>{
            //console.log(res);
            if( res.ok ){
                setStates({kbins:res.kbins,currentIndex:-1,editIndex:-1,action:'',cond:cond,pager:res.pager,items:[],selectedItems:[],isLoading:false,isItems:false});
            } else {
                setStates({...states,kbins:[],pager:null,"isLoading":false});
            }
        });
    }
	const jump = (p:number)=>{
		//send(values,p);
		page = p;
		search(states.cond);
	}
	const KbinRow = (props:{kbin:any,owner_id:number,index:number})=>{
		const [rowstates,setRowstates] = useState({
			open:false,
			entry_status: props.kbin.entry_status,
			selectedItems: [] as Item[],
			items:[] as Item[],
			isItems: false,
			action: '',
			toast: '',
			isLoading: false,
		});
		const toggle = async ()=>{			
			if( rowstates.open ){
				setRowstates({...rowstates,selectedItems:[],open:false});
				return;
			} else {
				const res = await Ajax.sendAwait("kbin/checkitems",{kbin_id:props.kbin.kbin_id});
				setRowstates({...rowstates,selectedItems:res.items,open:!rowstates.open});
			}
		}
		const openItems = async ()=>{
			const res = await Ajax.sendAwait("kbin/items",{kbin_id:props.kbin.kbin_id});
			if( res.ok ){
				setRowstates({...rowstates,items:res.items,isItems:true});
			}
		}
		const closeItems = ()=>{
			setRowstates({...rowstates,items:[],isItems:false});
		}
		const openEntry = ()=>{
			setRowstates({...rowstates,action:'entry'});
		}
		const closeEntry = ()=>{
			setRowstates({...rowstates,action:''});
		}
		const openCancel = ()=>{
			setRowstates({...rowstates,action:'cancel'});
		}
		const closeCancel = ()=>{
			setRowstates({...rowstates,action:''});
		}	
		const updateSelectedItems = async (items:Item[])=>{
			let item_ids = [] as number[];
			for( let i=0; i<items.length; i++ ){
				item_ids.push(items[i].item_id);
			}
			const res = await Ajax.sendAwait("kbin/updateitems",{kbin_id:props.kbin.kbin_id,item_ids:item_ids.join("_")});
			if( res.ok ){
				setRowstates({...rowstates,toast:'参加商品を更新しました',selectedItems:res.items,isItems:false});	
			}
		}
		const actionYes = ()=>{
			if( rowstates.action==='entry' ){
				addEntry();
			} else if( rowstates.action==='cancel' ){
				deleteKbin();
			}
		}
		const actionNo = ()=>{
			if( rowstates.action==='entry' ){
				closeEntry();
			} else if( rowstates.action==='cancel' ){	
				closeCancel();
			}
		}
		const addEntry = async ()=>{
			setRowstates({...rowstates,isLoading:true});
			const res = await Ajax.sendAwait("kbin/addentry",{kbin_id:props.kbin.kbin_id});
			if( res.ok ){
				setRowstates({...rowstates,action:'',toast:'参加申込が完了しました',entry_status:'1',isLoading:false});
			} else {
				setRowstates({...rowstates,action:'',isLoading:false});
			}
		};
		const deleteKbin = async ()=>{
			setRowstates({...rowstates,isLoading:true});
			const res = await Ajax.sendAwait("kbin/deleteentry",{kbin_id:props.kbin.kbin_id});
			if( res.ok ){
				setRowstates({...rowstates,action:'',toast:'参加申込をキャンセルしました',selectedItems:[],entry_status:'0',isLoading:false});
			} else {
				setRowstates({...rowstates,action:'',isLoading:false});
			}
		}
		const closeToast = ()=>{
			setRowstates({...rowstates,toast:''});
		}
		
		return (
			<>
			<TableRow style={{width:'100%'}}>
				<TableCell className={classes.tableCellNowrap} sx={{width:{xs:'75px',sm:'100px'}}} align='center'>
					<div style={{position:'relative',marginTop:'0.5em'}}>
						<img src={Tools.getKbinImg(props.kbin.kbin_id,'icon.png')} style={{width:'100%'}}/>
						{(props.kbin.status!=='9' && rowstates.entry_status==='1') && <div style={{position:'absolute',top:'0',right:'0',fontSize:'80%',padding:'0 0.5em',borderRadius:'0 0 0 0.5em',backgroundColor:'teal',color:'white'}}>参加中</div>}
					</div>
				</TableCell>
				<TableCell className={classes.tableCellNowrap} style={{width:'auto',overflow:'hidden',textOverflow:'ellipsis'}} align='left'>
					<span style={{color:'teal'}}>ID:{props.kbin.kbin_id}</span><br/>
					{props.kbin.name}<br/>
					<Box sx={{display:{xs:'block',sm:'none'}}}>
						{Tools.colorLabel("kbin_status",props.kbin.status,props.kbin.status_label)}
						<span style={{marginLeft:'0.5em'}}>{props.kbin.start}</span>
					</Box>
				</TableCell>
				<TableCell className={classes.tableCellNowrap} sx={{display:{xs:'none',sm:'table-cell'},width:'8em'}} align='center'>
					{props.kbin.start}<br/>
					{props.kbin.start_hour}<br/>
				</TableCell>
				<TableCell className={classes.tableCellNowrap} sx={{display:{xs:'none',sm:'table-cell'},width:'3.5em'}} align='center'>
					{Tools.colorOneLabel("kbin_status",props.kbin.status,props.kbin.status_label)}
				</TableCell>
				<TableCell className={classes.tableCellNowrap} align="center" sx={{width:{xs:'1.0em',sm:'2em'}}}><IconButton size="small" sx={{padding:'0',margin:'0',marginRight:{xs:'0',sm:'0.5em'}}} onClick={toggle}><ArrowDropDownIcon style={{color:'brown'}}/></IconButton></TableCell>
			</TableRow>
			{rowstates.open &&
			<TableRow>
				<TableCell style={{ padding: 0, paddingBottom: '3em' }} colSpan={isCompact ? 3 : 5}>
					<Table>
						<TableBody>
							<TableRow>
								<TableCell sx={{fontSize:'90%',backgroundColor:'#F5F5F5',width:{xs:'35%',sm:'20%',md:'15%'}}}>
								イベント
								</TableCell>
								<TableCell>
									{props.kbin.theme && <div style={{color:'#666666',fontSize:'90%'}}>{props.kbin.theme}</div>}
									{props.kbin.name}
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell sx={{fontSize:'90%',backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
								主催者
								</TableCell>
								<TableCell>
									{props.kbin.entry_point==='1' ? <div>架空ストア</div> : <div>{props.kbin.organizer}</div>}
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell sx={{fontSize:'90%',backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
								開催期間
								</TableCell>
								<TableCell>
									{props.kbin.start} {props.kbin.start_hour} から<br/>
									{props.kbin.end} {props.kbin.end_hour} まで<br/>
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell sx={{fontSize:'90%',backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
								公式サイト
								</TableCell>
								<TableCell style={{width:'auto',overflow:'hidden',textOverflow:'ellipsis'}}>
									<a href={props.kbin.url} target="_blank" style={{color:'teal',wordBreak:'break-all'}}>{props.kbin.url}</a>
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell sx={{fontSize:'90%',backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
								商品要件
								</TableCell>
								<TableCell>
									{props.kbin.requirements && <MultiLines text={props.kbin.requirements}/>}
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell sx={{fontSize:'90%',backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
								対象商品
								</TableCell>
								<TableCell>
									{props.kbin.entry_count>0 ? <span>登録商品から選択（{props.kbin.entry_count}点以内）</span> : <span>登録商品すべて</span>}
								</TableCell>
							</TableRow>
							<TableRow>
								<TableCell sx={{fontSize:'90%',backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
								参加登録
								</TableCell>
								{props.kbin.status==='0' &&
								<TableCell>
								{(!rowstates.entry_status || rowstates.entry_status==="0") && props.kbin.entry_point==="1" && <span style={{color:'orange'}}>参加受付中</span>}
								{(!rowstates.entry_status || rowstates.entry_status==="0") && props.kbin.entry_point==="2" && <span style={{color:'brown'}}>主催者の承認が必要です</span>}
								{rowstates.entry_status==="1" && <span style={{color:'green'}}>参加承認済</span>}
								{rowstates.entry_status==="9" && <span style={{color:'purple'}}>承認されませんでした</span>}
								<div style={{fontSize:'90%',color:'#663333',paddingTop:'0.5em',marginTop:'0.5em'}}>
									※「開催中」および「開催前」であれば、参加申込のキャンセルは何度でも可能です<br/>
									※原則として「開催中」は参加申込を受け付けません<br/>
								</div>
								</TableCell>}

								{props.kbin.status==='1' &&
								<TableCell>
								{rowstates.entry_status==="1" ? <span style={{color:'teal'}}>参加中</span> : <span style={{color:'gray'}}>参加受付は終了しました</span>}
								<div style={{fontSize:'90%',color:'#663333',paddingTop:'0.5em',marginTop:'0.5em'}}>
									※「開催中」および「開催前」であれば、参加申込のキャンセルは何度でも可能です<br/>
									※原則として「開催中」は参加申込を受け付けません<br/>
								</div>
								</TableCell>}

								{props.kbin.status==='9' &&
								<TableCell>
									このＫ便鉄道は終了しました
								</TableCell>}
							</TableRow>
							{props.kbin.status!=='9' && <TableRow>
								<TableCell sx={{fontSize:'90%',backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
								参加方法
								</TableCell>
								<TableCell>
									{props.kbin.entry_point==='1' && <div>
										すぐに「参加申込」できます
									</div>}
									{props.kbin.entry_point==='2' && <div>
										公式サイトの要綱をご確認の上、主催者にお申込み下さい。<br/>
										<div style={{fontSize:'90%',color:'#663333',paddingTop:'0.5em',marginTop:'0.5em'}}>
										※架空ストアへの参加申込は不要です。<br/>
										※架空ストアへの承認情報の反映は、主催者の承認から数日かかりますのでお待ち下さい。<br/>
										</div>
									</div>}
								</TableCell>
							</TableRow>}
							<TableRow>
								<TableCell sx={{fontSize:'90%',backgroundColor:'#F5F5F5',width:{xs:'30%',sm:'25%',md:'20%'}}}>
								参加商品
								</TableCell>
								<TableCell>
									{rowstates.selectedItems && rowstates.selectedItems.length>0 && rowstates.selectedItems.map((item:any,index:number)=>{
										return <div key={"item"+index}>
											<span className={classes.itemId}>ID:{item.item_id}</span>　
											{item.hide_flag==='0' ? item.item_name : <span style={{color:'gray'}}>（削除済の商品）</span>}
										</div>
									})}
									{rowstates.selectedItems && rowstates.selectedItems.length===0 && <div>参加商品は未登録です</div>}
									{!rowstates.selectedItems && <div id="loading"><CircularProgress/></div>}
									{props.kbin.entry_count>0 &&
									<div style={{fontSize:'90%',color:'#663333',paddingTop:'0.5em',marginTop:'0.5em'}}>
										{rowstates.entry_status==='0' && <div>※参加申込をしてから商品を選んで下さい<br/></div>}
										{rowstates.entry_status==='1' && <div>※「開催前」であれば何度でも選びなおせます<br/></div>}
									</div>}
								</TableCell>
							</TableRow>
						</TableBody>
					</Table>
					<Box sx={{ marginTop:'0.5em', display: 'flex',justifyContent: 'space-between' }}>
						<Box>
							{props.kbin.status!=='9' && rowstates.entry_status==="1" && <Button variant="text" size="small" color="error" disabled={rowstates.entry_status==="0"} onClick={openCancel}><DeleteForeverIcon style={{marginRight:'0.25em'}}/>参加申込のキャンセル</Button>}
						</Box>
						<Box>
							{(props.kbin.entry_count>0 && rowstates.entry_status==="1") && <Button variant="outlined" size="small" color="primary" disabled={props.kbin.status!=="0"} onClick={openItems} ><AddIcon style={{marginRight:'0.25em'}}/>商品選択</Button>}
							{(props.kbin.entry_point==="1" && rowstates.entry_status==="0") && <Button variant="outlined" size="small" color="primary" disabled={props.kbin.status!=="0"} onClick={openEntry}><FestivalIcon style={{marginRight:'0.25em'}}/>参加申込</Button>}
						</Box>
					</Box>
				</TableCell>
			</TableRow>
			}
			<KbinItems isOpen={rowstates.isItems} items={rowstates.items} owner={pr.owner} kbin={props.kbin} next={updateSelectedItems} close={closeItems}/>
			<Yesno mes={rowstates.action==='cancel' ? "このＫ便鉄道への参加をキャンセルしてよろしいですか？" : "このＫ便鉄道に参加しますか？"} isOpen={rowstates.action!==''} yes={actionYes} no={actionNo}/>
			<Loading isLoading={rowstates.isLoading}/>
			<Toast mes={rowstates.toast} close={closeToast}/>
			</>
		);
	}
	const kbinRows = useMemo(()=>{
		return states.kbins.map((kbin:any,index:number)=>{
			const key = "kbin"+index;
			return <KbinRow kbin={kbin} owner_id={pr.owner.owner_id} index={index} key={key}/>
		})
	},[states.kbins,isCompact])

	if( pr.owner.owner_id===0 ){
		return <Redirect to="/profile"/>
	}
	
	return (
		<div id="kbin_list" className={classes.root}>
            <Grid container spacing={2}>
                <Grid item xs={12} md={8} lg={9}>
                    <Paper className={classes.paper}>
                        <Title text="Ｋ便鉄道参加" icon="cart"/>
                        <div style={{marginBottom:"2em"}}>
	                        すでに終了したものも含めたＫ便鉄道の一覧です。架空ストア主催の場合は、ここからすぐに参加申込が可能です。<br/>
    	                    参加が決まったＫ便鉄道については、商品要件に従って参加商品を選んで下さい。<br/>
                        </div>
                        <Table style={{tableLayout: "fixed"}}>
                            <TableHead sx={{display:{xs:'none',sm:'table-header-group'}}}>
                                <TableRow>
									<TableCell className={classes.tableHeadNowrap} align="center" sx={{width:{xs:'75px',sm:'100px'}}}>　</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center">便名/コラボ相手</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center" sx={{width:'8em',display:{xs:'none',sm:'table-cell'}}}>開始日時</TableCell>
									<TableCell className={classes.tableHeadNowrap} align="center" sx={{width:'3.5em',display:{xs:'none',sm:'table-cell'}}}>状態</TableCell>
									<TableCell className={classes.tableHeadNowrap} sx={{width:{xs:'1em',sm:'2em'}}}>　</TableCell>
                                </TableRow>
                            </TableHead>

                            <TableBody>{kbinRows}</TableBody>
                        </Table>
						<div style={{padding:"1em"}}>
						{Tools.pager(states.pager,jump)}
						</div>
                    </Paper>
                </Grid>
                <Grid item xs={12} md={4} lg={3}>
                    <Paper className={classes.paper}>
                        <KbinListSearch update={search} bank={pr.bank} bankKey={"savedKbinListItemSearchCondition"}/>
                    </Paper>
                </Grid>
            </Grid>
            <Loading isLoading={states.isLoading}/>
		</div>
	);
}

export default KbinList;
